@if (state().notApplicable) {
  <div class="header-divider"></div>
  <app-section-not-applicable-card
    [comment]="state().notApplicableComment"
    [updatedBy]="state().notApplicableUpdatedBy"
    [updatedAt]="state().notApplicableUpdatedAt"
    [isSaving]="isSaving()"
    (reactivate)="onReactivate()"
  />
} @else if (isEnteringReason()) {
  <div class="header-divider"></div>
  <app-section-not-applicable-form
    [isSaving]="isSaving()"
    (confirmed)="onConfirm($event)"
    (cancelled)="onCancel()"
  />
}
